import React, { useState } from "react";
import Footer from "../components/Footer";
import ScrollAdd from "../components/ScrollAdd";
import Navbar from "../components/Navbar";
import { API_BASE } from "../api";
import "./Enrollment.css";


const schoolsData = [
  {
    id: "gramayana",
    name: "Residential Summer Camp – Gramayana Edition 2026",
    venue: "Shivalingapuram, Kadthal Village",
    fee: "₹9,500",
    amount: 9500,
  },
  {
    id: "tech-gen-iris",
    name: "Tech Generation Summer Camp 2026 (IRIS Florets)",
    venue: "IRIS Florets World School, Bongloor",
    fee: "₹4,499",
    amount: 4499,
  },
  {
    id: "tech-gen-jubilee",
    name: "Tech Generation Summer Camp 2026 (Jubilee Hills)",
    venue: "Ekagra Chess Academy, Jubilee Hills",
    fee: "₹9,999",
    amount: 9999,
  },
  {
    id: "tech-gen-meridian",
    name: "Tech Generation Summer Camp 2026 (Meridian School)",
    venue: "Meridian School, Uppal, Hyderabad",
    fee: "₹4,499",
    amount: 4499,
  },
];

const Enrollment = () => {
  const [formData, setFormData] = useState({
    childName: "",
    dateOfBirth: "",
    gender: "",
    schoolName: "",
    branchName: "",
    gradeClass: "",
    parentName: "",
    relationshipToChild: "",
    contactNumber: "",
    emailAddress: "",
    emergencyContactPerson: "",
    emergencyContactNumber: "",
    hasAllergiesOrMedicalConditions: "",
    currentMedications: "",
    agreementConfirmed: false,

  });

  const [amount, setAmount] = useState(0);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSchoolSelect = (school) => {
    setFormData((prevData) => ({
      ...prevData,
      schoolName: `${school.name}: ${school.fee}`,
    }));
    setAmount(school.amount);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formatDate = (date) => {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    };
    const formatGender = (gender) =>
      gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();

    const postData = {
      child_full_name: formData.childName,
      date_of_birth: formatDate(formData.dateOfBirth),
      gender: formatGender(formData.gender),
      school_name: formData.schoolName,
      branch_name: formData.branchName,
      grade_class: formData.gradeClass,
      parent_full_name: formData.parentName,
      relationship_to_child: formData.relationshipToChild,
      contact_number: formData.contactNumber,
      email_address: formData.emailAddress,
      emergency_contact_person: formData.emergencyContactPerson,
      emergency_contact_number: formData.emergencyContactNumber,
      medical_conditions: formData.hasAllergiesOrMedicalConditions,
      current_medications: formData.currentMedications,
      amount: amount,
    };

    try {
      const response = await fetch(
        `${API_BASE}/api/enroll`,
        {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error: ${errorData.error || "An unexpected error occurred."}`);
        return;
      }

      const data = await response.json();

      const options = {
        key: data.key,
        amount: data.amount * 100,
        currency: "INR",
        name: "Learnorama",
        description: "Camp Enrollment",
        order_id: data.orderId,

        handler: async function (response) {

          localStorage.setItem("txn", data.transactionId);

          const verifyRes = await fetch(`${API_BASE}/api/payments/razorpay/verify`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              transactionId: data.transactionId
            })
          });

          if (verifyRes.ok) {
            window.location.href = "/#/payment-success";
          } else {
            alert("Payment verification failed. Please contact support.");
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      alert(
        "There was an error submitting your enrollment application. Please try again later."
      );
    }
  };

  // const handleTestFill = () => {
  //   setFormData({
  //     childName: "John Doe Jr.",
  //     dateOfBirth: "2015-05-20",
  //     gender: "male",
  //     schoolName: "Residential Summer Camp – Gramayana Edition 2026: ₹9,500",
  //     branchName: "DPS Hyderabad",
  //     gradeClass: "5th Grade",
  //     parentName: "John Doe Sr.",
  //     relationshipToChild: "Father",
  //     contactNumber: "9988776655",
  //     emailAddress: "john.doe@example.com",
  //     emergencyContactPerson: "Jane Doe",
  //     emergencyContactNumber: "9988443322",
  //     hasAllergiesOrMedicalConditions: "None",
  //     currentMedications: "None",
  //     agreementConfirmed: true,
  //   });
  //   setAmount(9500);
  // };

  return (
    <div className="enrollment-page-wrapper">
      <ScrollAdd />
      <Navbar />

      <div className="heading-main-box">
        <h5>Learnorama</h5>
        <h1 id="font-color">TECH GENERATION SUMMER CAMP 2026</h1>
        <p>Organized by Learn Orama Technologies Pvt Ltd</p>
        <h1>Enrollment Application</h1>

        <h2 className="LearnMorePage-section-title">Logistics and Fees</h2>
        <p>
          <strong>Note:</strong> Transportation and hostel facilities are
          available. <strong>(Bookings open soon)</strong>
        </p>
      </div>

      {/* <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        <button
          type="button"
          onClick={handleTestFill}
          style={{
            background: '#ff4757',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Test Fill Form
        </button>
      </div> */}

      <form onSubmit={handleSubmit}>
        <h2>Child's Information</h2>

        <label>
          Full Name of Child
          <input
            type="text"
            name="childName"
            value={formData.childName}
            onChange={handleChange}
            placeholder="Enter child's full name"
            required
          />
        </label>

        <label>
          Date of Birth
          <input
            type="date"
            name="dateOfBirth"
            value={formData.dateOfBirth}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Gender
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </label>

        <label>
          Present School Name
          <input
            type="text"
            name="branchName"
            value={formData.branchName}
            onChange={handleChange}
            placeholder="Enter current school"
            required
          />
        </label>

        <label>
          Select Your School for Summer Camp
          <div className="school-selection-grid">
            {schoolsData.map((school) => (
              <div
                key={school.id}
                className={`school-card ${formData.schoolName === `${school.name}: ${school.fee}`
                  ? "selected"
                  : ""
                  }`}
                onClick={() => handleSchoolSelect(school)}
              >
                <h3>{school.name}</h3>
                <p className="venue">{school.venue}</p>
                <p className="fee">{school.fee}</p>
              </div>
            ))}
          </div>
          <input
            type="hidden"
            name="schoolName"
            value={formData.schoolName}
            required
          />
        </label>

        {amount > 0 && (
          <div className="fee-display-box">
            Selected Camp Fee: ₹{amount.toLocaleString()}
          </div>
        )}

        <label>
          Grade/Class
          <input
            type="text"
            name="gradeClass"
            value={formData.gradeClass}
            onChange={handleChange}
            placeholder="e.g. 5th Grade"
            required
          />
        </label>

        <h2>Parent/Guardian Information</h2>

        <label>
          Full Name of Parent/Guardian
          <input
            type="text"
            name="parentName"
            value={formData.parentName}
            onChange={handleChange}
            placeholder="Enter your full name"
            required
          />
        </label>

        <label>
          Relationship to Child
          <input
            type="text"
            name="relationshipToChild"
            value={formData.relationshipToChild}
            onChange={handleChange}
            placeholder="e.g. Mother, Father"
            required
          />
        </label>

        <label>
          Contact Number
          <input
            type="tel"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            placeholder="Enter mobile number"
            required
          />
        </label>

        <label>
          Email Address
          <input
            type="email"
            name="emailAddress"
            value={formData.emailAddress}
            onChange={handleChange}
            placeholder="Enter email address"
            required
          />
        </label>

        <h2>Emergency Contact Information</h2>

        <label>
          Emergency Contact Person
          <input
            type="text"
            name="emergencyContactPerson"
            value={formData.emergencyContactPerson}
            onChange={handleChange}
            placeholder="Enter contact person name"
            required
          />
        </label>

        <label>
          Emergency Contact Number
          <input
            type="tel"
            name="emergencyContactNumber"
            value={formData.emergencyContactNumber}
            onChange={handleChange}
            placeholder="Enter emergency number"
            required
          />
        </label>

        <h2>Medical Information</h2>

        <label>
          Does the child have any allergies or medical conditions?
          <textarea
            name="hasAllergiesOrMedicalConditions"
            value={formData.hasAllergiesOrMedicalConditions}
            onChange={handleChange}
            placeholder="Provide details if any..."
          />
        </label>

        <label>
          Current Medications (if any)
          <input
            type="text"
            name="currentMedications"
            value={formData.currentMedications}
            onChange={handleChange}
            placeholder="List medications"
          />
        </label>

        <h2>Declaration</h2>

        <div className="declaration-container">
          <input
            type="checkbox"
            id="agreementConfirmed"
            name="agreementConfirmed"
            checked={formData.agreementConfirmed}
            onChange={handleChange}
            required
          />
          <label htmlFor="agreementConfirmed" style={{ marginBottom: 0 }}>
            I, the undersigned, hereby confirm that the information provided in
            this enrollment application is accurate and complete. I understand and
            agree to comply with the terms and conditions outlined by Learnorama
            Summer Camp.
          </label>
        </div>

        <div className="submit-container">
          <button className="button-2" type="submit">
            Submit Application
          </button>
        </div>
      </form>

      <Footer />
    </div>
  );
};

export default Enrollment;
